import UnstyledImage from '@components/Image';
import styled, { css } from 'styled-components';

import { weights } from '@utils/fonts';
import { mq } from '@utils/responsive';
import { CONTENT_MAX_WIDTH, H_PADDING_MOBILE } from '@utils/space';

export const FigCaption = styled.figcaption`
  margin-top: 8px;
  padding: 0 ${H_PADDING_MOBILE};
  text-align: left;

  ${mq.gtsm`
    margin: 16px 0 0;
    padding: 0;
  `}

  & em {
    display: inline-block;
    font-weight: ${weights.BOLD};
    margin-left: 4px;
  }
`;

export const Figure = styled.figure`
  height: 100%;
  text-align: center;

  ${mq.gtlg`
    width: ${8 / 12 * 100}%;
    margin: 0 auto;

    ${(props) =>
    props.isVerticalImage &&
    css`
        width: 100vw;
      `}
  `}
`;

export const Image = styled(UnstyledImage)`
  ${mq.gtsm`
    height: 100%;
  `}
`;

export const ImageWrapper = styled.div`
  ${mq.gtmd`
    display: inline-block;
    height: 100%;

    ${(props) => props.isVerticalImage ? css`
      ${Image},
      ${FigCaption} {
        width: 50vw;
      }
    ` : css `
      width: 100%;
    `}
  `}
`;

export const Wrapper = styled.div`
  width: 100%;
`;

const JUSTIFY = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

export const SizedWrapper = styled.div`
  display: flex;
  justify-content: ${(props) => JUSTIFY[props.$alignment] || 'center'};
  max-width: ${CONTENT_MAX_WIDTH}px;
  margin: 0 auto;
  padding: 0 ${H_PADDING_MOBILE};

  ${mq.gtml`
    padding: 0;
  `}
`;

export const TextWidthImage = styled.div`
  width: 100%;
`;

export const SizedCaption = styled.figcaption`
  margin-top: 8px;
  text-align: left;

  ${mq.gtsm`
    margin-top: 16px;
  `}

  & em {
    display: inline-block;
    font-weight: ${weights.BOLD};
  }
`;
